import { render, staticRenderFns } from "./SplitPaymentView.vue?vue&type=template&id=62aa600a"
import script from "./SplitPaymentView.vue?vue&type=script&lang=js"
export * from "./SplitPaymentView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports